module.exports = __webpack_public_path__ + "assets/images/project/head/Heidy_Quah.jpg?v=4941dbc2";